import { render, staticRenderFns } from "./server_error.vue?vue&type=template&id=1d83aaf7&scoped=true&"
import script from "./server_error.vue?vue&type=script&lang=js&"
export * from "./server_error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d83aaf7",
  null
  
)

export default component.exports